import { Component, signal } from '@angular/core';
import { AppShellComponent } from './layout/app-shell/app-shell.component';
import { ToastContainerComponent, ConfirmDialogComponent } from './shared';
import { DevToolsComponent } from './components/dev-tools/dev-tools.component';
import { QrButtonComponent } from './components/qr-button/qr-button.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    AppShellComponent, 
    ToastContainerComponent, 
    ConfirmDialogComponent, 
    DevToolsComponent,
    QrButtonComponent
  ],
  template: `
    <app-shell></app-shell>
    <app-toast-container></app-toast-container>
    <app-confirm-dialog></app-confirm-dialog>
    <app-qr-button></app-qr-button>
    <app-dev-tools></app-dev-tools>
  `,
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('insee-ihub');
}
